<template>
    <div :class="`${shouldClip ? 'clipped' : ''}`">
        <template v-for="(part, index) in parts">
            <template v-if="part.highlighted">
                <span class="highlighted" :key="index">{{ part.text }}</span>
            </template>
            <template v-else>
                {{ part.text }}
            </template>
        </template>
    </div>
</template>

<script>
export default {
    name: 'HighlightedAddressText',
    props: {
        text: {
            type: String,
            required: true
        },
        highlights: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        shouldClip() {
            return this.highlights.length !== 0;
        },
        parts() {
            /**
             * convert the text into parts with highlighted parts
             * highlights is an array of objects with the ff. structure
             * {
             *    offset: number,
             *    length: number
             *  }
             *  where offset is the starting index of the highlighted text, index starts at 0,
             *  and length is the length of the highlighted text
             */
            const { text, highlights } = this;
            if (highlights.length === 0) {
                return [{ text, highlighted: false }];
            }
            // Sort highlights by offset to ensure correct order
            highlights.sort((a, b) => a.offset - b.offset);
            const parts = [];
            let currentIndex = 0;

            highlights.forEach(({ offset, length }) => {
                // Add non-highlighted text before the current highlight
                if (currentIndex < offset) {
                    parts.push({
                        text: text.slice(currentIndex, offset),
                        highlighted: false
                    });
                }

                // Add highlighted text
                parts.push({
                    text: text.slice(offset, offset + length),
                    highlighted: true
                });

                // Update current index
                currentIndex = offset + length;
            });

            // Add remaining non-highlighted text after the last highlight
            if (currentIndex < text.length) {
                parts.push({
                    text: text.slice(currentIndex),
                    highlighted: false
                });
            }

            return parts;
        }
    }
};
</script>
<style scoped lang="scss">
.highlighted {
    font-weight: bold;
}
.clipped {
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
}
</style>
